<template>
  <b-card class="m-4">
    <b-tabs card pills>
      <b-tab active title="Create Popup">
        <b-card-text>
          <div class="form-group">
            <label>Title</label>

            <input class="form-control" title="text" v-model="title" />
          </div>
          <div class="form-group">
            <label>Body</label>
            <input class="form-control" title="text" v-model="body" />
          </div>
          <div class="form-group">
            <label>Day</label>
           <select v-model="day" class="form-control">
              <option value="monday">Monday</option>
              <option value="tuesday">Tuesday</option>
              <option value="wednesday">Wednesday</option>
              <option value="thursday">Thursday</option>
              <option value="friday">Friday</option>
              <option value="saturday">Saturday</option>
              <option value="sunday">Sunday</option>
            </select>
          </div>
          <div class="form-group">
            <label>Hour</label>
            <input
              class="form-control"
              title="text"
              v-model="hour"
              type="number"
              min="6"
              value="6"
            />
          </div>
          <div class="form-group">
            <label>Minute</label>
            <input
              class="form-control"
              title="text"
              v-model="minute"
              type="number"
              min="0"
            />
          </div>

          <div class="form-group">
            <label>Status</label>
            <select v-model="status" class="form-control">
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          <div class="form-group">
            <label>Upload Image</label>
            <input
              class="form-control"
              title="file"
              type="file"
              v-on:change="onImageChange"
            />
          </div>
          <CButton @click="onSubmit" color="primary">
            <CIcon name="cil-check-circle" />Add schedule Notification
          </CButton>

          <!--          <b-button @click="onSubmit" type="submit" variant="primary"><i class="fa fa-dot-circle-o"></i> Create Noti-->
          <!--          </b-button>-->
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import axios from "axios";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const BASE_URL = "https://shera-es.s3.ap-south-1.amazonaws.com/p";
export default {
  name: "createScheduleNotification",
  data() {
    return {
      title: "",
      body: "",
      hour: "",
      day:"",
      minute: "",
      banner: "",
      status: "",
    };
  },
  methods: {
    onImageChange(e) {
      this.banner = e.target.files[0];
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-title": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("body", this.body);
      formData.append("day", this.day);
      formData.append("hour", this.hour);
      formData.append("minute", this.minute);
      formData.append("banner", this.banner);
      formData.append("status", this.status);

      const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

      axios
        .post(`${ADMIN_URL}/schedule-notification/store`, formData)
        .then((response) => {
          return this.$router.push("/schedule-notification");
        })
        .catch((error) => {});
    },
    // changeDateFormat(){
    //   let d = this.date;
    //   let month = '' + (d.getMonth() + 1);
    //   let day = '' + d.getDate();
    //   let year = d.getFullYear();
    //   if (month.length < 2) month = '0' + month;
    //   if (day.length < 2) day = '0' + day;
    //
    //   this.date =  [year, month, day].join('-');
    // },
  },
};
</script>

<style scoped></style>
